module.exports = __webpack_public_path__ + "static/media/camion.164bed8e.jpg";